export const getCostFormat = (num, digits = 6) => {
  const numFormat = Number(num) < 1 ? parseFloat(num) : Number(num);
  const result = numFormat.toLocaleString(undefined, {
    maximumFractionDigits: digits,
  });

  return result;
};
